import { render } from "./RecordFormModal.vue?vue&type=template&id=334ea3bc"
import script from "./RecordFormModal.vue?vue&type=script&lang=js"
export * from "./RecordFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__